export default "__VITE_ASSET__Bczd4sfJ__"